import { SHARE_CHALLENGE_URL } from "@/config/shareChallenge";

/*
  Shared "Share your challenge" control.

  Behavior is driven entirely by SHARE_CHALLENGE_URL:
  - null  -> renders a <button type="button"> that looks fully active
             (pointer cursor + hover/focus states) but does nothing on click.
  - a URL -> renders an <a href target="_blank" rel="noopener"> opening in a
             new tab.

  Appearance is controlled by the caller via `className`, so the exact styling
  for each placement is preserved (btn btn--primary in the hero / CTA band,
  nav-link in the header, footer-link in the footer, etc.). Any extra props
  (data-testid, aria-*, etc.) are forwarded to the rendered element.
*/
export default function ShareCTA({ className, children, ...rest }) {
  if (SHARE_CHALLENGE_URL) {
    return (
      <a
        href={SHARE_CHALLENGE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={className} {...rest}>
      {children}
    </button>
  );
}
